import IntentProjectEnvironmentVariablesTableIdCell from "./IdCell";
import IntentProjectEnvironmentVariablesTableValueCell from "./ValueCell";
import IntentProjectEnvironmentVariablesTableDescriptionCell from "./DescriptionCell";
import IntentProjectEnvironmentVariablesTableCreatedAtCell from "./CreatedAtCell";
import IntentProjectEnvironmentVariablesTableRowActionsCell from "./RowActionsCell";
import { INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID } from "../constants";

export const INTENT_PROJECT_ENVIRONMENT_VARIABLES_TABLE_CELLS = {
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.ID]: IntentProjectEnvironmentVariablesTableIdCell,
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DESCRIPTION]:
    IntentProjectEnvironmentVariablesTableDescriptionCell,
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.VALUE]:
    IntentProjectEnvironmentVariablesTableValueCell,
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.CREATED_AT]:
    IntentProjectEnvironmentVariablesTableCreatedAtCell,
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DROPDOWN]:
    IntentProjectEnvironmentVariablesTableRowActionsCell,
};
